<template>
  <div class="form-step">
    <div class="details-left">
      Schedule Appointment
    </div>
    <div class="title-box">
      <div class="section-title">
        Are you an existing patient?
      </div>
      <p class="section-paragraph">
        Please select the type of appointment that you would like to schedule.
      </p>
    </div>
    <div class="form-fields">
      <div class="radio-btn-wrapper" :class="formData.existingPatient === 'yes' ? 'selected-radio' : ''" @click="radioSelected('yes')">
        <div class="card-content">
          <span class="card-title">Yes</span><br>
          <span class="card-icon">
            <b-icon icon="calendar-check"></b-icon>
          </span><br>
          <span class="card-subtitle">Schedule a follow up appointment</span>
        </div>
      </div>
      <div class="radio-btn-wrapper" :class="formData.existingPatient === 'no' ? 'selected-radio' : ''" @click="radioSelected('no')">
        <div class="card-content">
          <span class="card-title">No</span><br>
          <span class="card-icon">
            <b-icon icon="calendar-plus"></b-icon>
          </span><br>
          <span class="card-subtitle">Schedule an initial consultation</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PatientType',
  props: {
    step: Number,
    steps: Number,
    data: Object
  },
  data () {
    return {
      formData: this.data
    }
  },
  methods: {
    updateData() {
      this.$emit('updateData', this.formData)
    },
    radioSelected(selection) {
      this.formData.existingPatient = selection
    }
  }
}
</script>

<style scoped>
.details-left {
  position: absolute;
  left: 0;
  top: 0;
  margin-top: 15px;
  margin-left: 15px;
  color: #40805b;
  font-size: 18px;
}
.details-right {
  position: absolute;
  top: 0;
  right: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-top: 15px;
  margin-right: 15px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: rgba(32,38,44,.38);
  font-size: 18px;
}
.title-box {
  display: flex;
  padding-top: 100px;
  margin-bottom: 35px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
}
.section-title {
  padding-left: 25px;
  padding-right: 25px;
  margin-bottom: 12px;
  font-size: 50px;
  font-weight: 600;
}
.section-paragraph {
  max-width: 500px;
  font-weight: 400;
  margin-right: auto;
  margin-left: auto;
  margin-top: 0;
  margin-bottom: 10px;
}
.form-fields {
  max-width: 550px;
  display: flex;
  width: 100%;
  margin-right: auto;
  margin-bottom: 5px;
  margin-left: auto;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-box-align: center;
  align-items: center;
  margin-top: 70px;
  grid-auto-columns: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  -ms-grid-columns: 1fr 1fr;
  grid-template-columns: 1fr 1fr;
  -ms-grid-rows: auto auto;
  grid-template-rows: auto auto;
}
.text-field {
  height: auto;
  margin-bottom: 0;
  padding: 20px 30px;
  border: 1px #000;
  border-radius: 33px;
  background-color: #eaebf0;
  color: #000;
  font-size: 20px;
  display: block;
  width: 100%;
  line-height: 1.42857143;
  margin: 0;
}
.radio-btn-wrapper {
  width: 220px;
  height: 220px;
  align-items: flex-end;
  overflow: hidden;
  border-radius: 50px;
  background-color: #fff;
  box-shadow: 0 30px 100px 0 rgb(60 60 60 / 20%), inset 0 34px 100px 0 rgb(60 60 60 / 10%);
  margin-left: auto;
  margin-right: auto;
  display: flex;
  transition: all 500ms;
}
.radio-btn-wrapper:hover {
  transition: all 500ms;
  box-shadow: 0 30px 100px 0 rgb(60 60 60 / 30%), inset 0 34px 100px 0 rgb(60 60 60 / 5%);
  transform: translateY(-12px);
}
.selected-radio {
  border-style: solid;
  border-width: 2px;
  border-color: #ff5666;
}
.selected-radio .card-icon {
  color: #ff5666;
}
.card-content {
  color: #000;
  margin-right: auto;
  margin-left: auto;
  height: 100%;
  padding: 20px;
}
.card-title {
  font-size: 22px;
  font-weight: 600;
}
.card-icon {
  color: #40805b;
  transition: all 300ms;
  font-size: 68px;
}
.card-subtitle {
  font-size: 14px;
}
@media (max-width: 780px) {
  .section-title {
    padding-left: 15px;
    padding-right: 15px;
    margin-bottom: 12px;
    font-size: 32px;
    font-weight: 600;
  }
}
.btn-next{
    margin-left: auto;
    margin-top: 50px;
    display: inline-block;
    font-family: Futurapt,sans-serif;
    color: #ff5666;
    font-size: 18px;
    line-height: 1.65;
    font-weight: 700;
    text-align: center;
    text-decoration: underline;
}
</style>